import { reports } from "./reports";
import { tableColumnTypes } from "../../tableColumnTypes";
import UserIcon from "../../../components/Common/SvgIcons/ReportIcons/UserIcon";
import ClassIcon from "../../../components/Common/SvgIcons/ReportIcons/ClassIcon";
import { FormattedMessage } from "react-intl";

export const tabularReport = {
  label: <FormattedMessage id="REPORT_TABULARRPT_LBL" />,
  path: (tenantName) => `/${tenantName}/reports/tabularReport`,
  radio: (navigate, tenantName) => [
    {
      key: 1,
      name: "yes",
      label: "Yes",
      // checked: "false",
      path: (tenantName) =>
        `/${tenantName}/reports/tabularReport/tabularAdvanceReport`,
      onClick: () =>
        navigate(`/${tenantName}/reports/tabularReport/tabularAdvanceReport`),
    },
    {
      key: 2,
      name: "yes",
      label: "No",
      // checked: "true",
      path: (tenantName) =>
        `/${tenantName}/reports/tabularReport/userTabularReport`,
      onClick: () =>
        navigate(`/${tenantName}/reports/tabularReport/userTabularReport`),
    },
  ],
  buttons: (navigate, tenantName) => [
    {
      key: 1,
      label: "User Level Report",
      path: `${tabularReport.path(tenantName)}/userTabularReport`,
      onClick: () =>
        navigate(`${tabularReport.path(tenantName)}/userTabularReport`),
      // path: (tenantName) =>
      //   `/${tenantName}/reports/tabularReport/userTabularReport`,
      icon: UserIcon,
      // onClick: () =>
      //   navigate(`/${tenantName}/reports/tabularReport/userTabularReport`),
    },
    {
      key: 2,
      label: "Class Level Report",
      path: `${tabularReport.path(tenantName)}/classTabularReport`,
      onClick: () =>
        navigate(`${tabularReport.path(tenantName)}/classTabularReport`),
      // path: (tenantName) =>
      //   `/${tenantName}/reports/tabularReport/classTabularReport`,
      icon: ClassIcon,
      // onClick: () =>
      //   navigate(`/${tenantName}/reports/tabularReport/classTabularReport`),
    },
  ],
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: "Reports",
      path: `${reports.path}`,
      onClick: () => navigate(`${reports.path(tenantName)}`),
    },
    {
      key: 2,
      label: "Tabular Report",
      path: `${reports.path}`,
      onClick: () => navigate(`${reports.path(tenantName)}`),
    },
  ],
  columns: (navigate, handleUserPopUp) => [
    {
      ID: 1,
      name: <FormattedMessage id="REPORT_USERNAME_TXT" />,
      fieldName: "UserName",
      value: (row) =>
        row.ClassesAssigned > 0 && (
          <span
            style={{
              textDecoration: "underline",
              color: "#0051BC",
              cursor: "pointer",
            }}
            onClick={() => handleUserPopUp(row.UserId)}
          >
            {/* {row.UserName} */}
            {row.UserName?.length > 25 ? row?.UserName?.slice(0, 23) + "..." : row?.UserName}
          </span>
        ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="Report_Assigned" />,
      fieldName: "ClassesAssigned",
      value: (row) => row.ClassesAssigned,
      sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 3,
      name: <FormattedMessage id="REPORT_NOTYETSTRT_TXT" />,
      fieldName: "ClassesNotStarted",
      value: (row) => row.ClassesNotStarted,
      sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 4,
      name: <FormattedMessage id="REPORT_INPROGESS_TXT" />,
      fieldName: "ClassesInProgress",
      value: (row) => row.ClassesInProgress,
      sort: true,
    },
    {
      ID: 5,
      name: <FormattedMessage id="Report_Completed" />,
      fieldName: "ClassesCompleted",
      value: (row) => row.ClassesCompleted,
      sort: true,
    },
    {
      ID: 6,
      name: <FormattedMessage id="REPORT_ARCHIVED_TEXT" />,
      fieldName: "Archived",
      value: (row) => row.Archived,
      sort: true,
    },
    {
      ID: 7,
      name: <FormattedMessage id="REPORT_COMPLETION_TXT" />,
      fieldName: "PercentageCompletion",
      value: (row) => row.PercentageCompletion,
      sort: true,
    },
  ],
};
